const TextStyle_TextAlignment = {
  AUTO: "AUTO",
  LEFT: "LEFT",
  RIGHT: "RIGHT",
  CENTER: "CENTER",
  JUSTIFY: "JUSTIFY"
};
const Link_Target = {
  SELF: "SELF",
  BLANK: "BLANK",
  PARENT: "PARENT",
  TOP: "TOP"
};
const VerticalAlignment = {
  TOP: "TOP",
  MIDDLE: "MIDDLE",
  BOTTOM: "BOTTOM"
};
const ImageScaling = {
  AUTO: "AUTO",
  CONTAIN: "CONTAIN",
  COVER: "COVER"
};
const ImagePosition = {
  CENTER: "CENTER",
  CENTER_LEFT: "CENTER_LEFT",
  CENTER_RIGHT: "CENTER_RIGHT",
  TOP: "TOP",
  TOP_LEFT: "TOP_LEFT",
  TOP_RIGHT: "TOP_RIGHT",
  BOTTOM: "BOTTOM",
  BOTTOM_LEFT: "BOTTOM_LEFT",
  BOTTOM_RIGHT: "BOTTOM_RIGHT"
};
const Gradient_Type = {
  LINEAR: "LINEAR",
  RADIAL: "RADIAL"
};
const Background_Type = {
  COLOR: "COLOR",
  GRADIENT: "GRADIENT"
};
const PluginContainerData_Alignment = {
  CENTER: "CENTER",
  LEFT: "LEFT",
  RIGHT: "RIGHT"
};
const PluginContainerData_Width_Type = {
  CONTENT: "CONTENT",
  SMALL: "SMALL",
  ORIGINAL: "ORIGINAL",
  FULL_WIDTH: "FULL_WIDTH"
};
const Decoration_Type = {
  BOLD: "BOLD",
  ITALIC: "ITALIC",
  UNDERLINE: "UNDERLINE",
  SPOILER: "SPOILER",
  ANCHOR: "ANCHOR",
  MENTION: "MENTION",
  LINK: "LINK",
  COLOR: "COLOR",
  FONT_SIZE: "FONT_SIZE",
  STRIKETHROUGH: "STRIKETHROUGH",
  SUPERSCRIPT: "SUPERSCRIPT",
  SUBSCRIPT: "SUBSCRIPT",
  FONT_FAMILY: "FONT_FAMILY"
};
const FontSizeData_fontType = {
  PX: "PX",
  EM: "EM"
};
const LayoutData_BannerOrigin = {
  IMAGE: "IMAGE",
  LAYOUT: "LAYOUT"
};
const LayoutData_ResponsivenessBehaviour = {
  STACK: "STACK",
  WRAP: "WRAP"
};
const LayoutData_DesignTarget = {
  LAYOUT: "LAYOUT",
  CELL: "CELL"
};
const AppEmbedData_AppType = {
  PRODUCT: "PRODUCT",
  EVENT: "EVENT",
  BOOKING: "BOOKING"
};
const AppEmbedData_ImageStyles_Position = {
  START: "START",
  END: "END",
  TOP: "TOP"
};
const AppEmbedData_ImageStyles_AspectRatio = {
  SQUARE: "SQUARE",
  RECTANGLE: "RECTANGLE"
};
const AppEmbedData_ImageStyles_Resizing = {
  FILL: "FILL",
  FIT: "FIT"
};
const AppEmbedData_RibbonStyles_Placement = {
  IMAGE: "IMAGE",
  PRODUCT_INFO: "PRODUCT_INFO"
};
const AppEmbedData_CardStyles_Type = {
  CONTAINED: "CONTAINED",
  FRAMELESS: "FRAMELESS"
};
const AppEmbedData_CardStyles_Alignment = {
  START: "START",
  CENTER: "CENTER",
  END: "END"
};
const ButtonData_Type = {
  LINK: "LINK",
  ACTION: "ACTION"
};
const ButtonData_Styles_ButtonSize = {
  MEDIUM: "MEDIUM",
  SMALL: "SMALL",
  LARGE: "LARGE"
};
const CollapsibleListData_Direction = {
  LTR: "LTR",
  RTL: "RTL"
};
const DividerData_LineStyle = {
  SINGLE: "SINGLE",
  DOUBLE: "DOUBLE",
  DASHED: "DASHED",
  DOTTED: "DOTTED"
};
const DividerData_Width = {
  LARGE: "LARGE",
  MEDIUM: "MEDIUM",
  SMALL: "SMALL"
};
const DividerData_Alignment = {
  CENTER: "CENTER",
  LEFT: "LEFT",
  RIGHT: "RIGHT"
};
const FileData_PDFSettings_ViewMode = {
  NONE: "NONE",
  FULL: "FULL",
  MINI: "MINI"
};
const GalleryOptions_Layout_Type = {
  COLLAGE: "COLLAGE",
  MASONRY: "MASONRY",
  GRID: "GRID",
  THUMBNAIL: "THUMBNAIL",
  SLIDER: "SLIDER",
  SLIDESHOW: "SLIDESHOW",
  PANORAMA: "PANORAMA",
  COLUMN: "COLUMN",
  MAGIC: "MAGIC",
  FULLSIZE: "FULLSIZE"
};
const GalleryOptions_Layout_Orientation = {
  ROWS: "ROWS",
  COLUMNS: "COLUMNS"
};
const GalleryOptions_ItemStyle_Crop = {
  FILL: "FILL",
  FIT: "FIT"
};
const GalleryOptions_Thumbnails_Alignment = {
  TOP: "TOP",
  RIGHT: "RIGHT",
  BOTTOM: "BOTTOM",
  LEFT: "LEFT",
  NONE: "NONE"
};
const GIFData_GIFType = {
  NORMAL: "NORMAL",
  STICKER: "STICKER"
};
const HTMLData_Source = {
  HTML: "HTML",
  ADSENSE: "ADSENSE",
  AI: "AI",
  AI_WIDGET: "AI_WIDGET"
};
const PollData_Poll_Settings_Permissions_ViewRole = {
  CREATOR: "CREATOR",
  VOTERS: "VOTERS",
  EVERYONE: "EVERYONE"
};
const PollData_Poll_Settings_Permissions_VoteRole = {
  SITE_MEMBERS: "SITE_MEMBERS",
  ALL: "ALL"
};
const PollData_Layout_PollLayout_Type = {
  LIST: "LIST",
  GRID: "GRID"
};
const PollData_Layout_PollLayout_Direction = {
  LTR: "LTR",
  RTL: "RTL"
};
const PollData_Design_PollDesign_Background_Type = {
  COLOR: "COLOR",
  IMAGE: "IMAGE",
  GRADIENT: "GRADIENT"
};
const SmartBlockData_Type = {
  SOLID_BOXES: "SOLID_BOXES",
  NUMBERED_BOXES: "NUMBERED_BOXES",
  STATS: "STATS",
  BAR_STATS: "BAR_STATS",
  CIRCLE_STATS: "CIRCLE_STATS",
  SOLID_BOXES_ALTERNATING: "SOLID_BOXES_ALTERNATING",
  SOLID_JOINED_BOXES: "SOLID_JOINED_BOXES",
  SIDE_LINE_TEXT: "SIDE_LINE_TEXT",
  TOP_LINE_TEXT: "TOP_LINE_TEXT",
  OUTLINE_BOXES_WITH_TOP_CIRCLE: "OUTLINE_BOXES_WITH_TOP_CIRCLE",
  BIG_BULLETS: "BIG_BULLETS",
  SMALL_BULLETS: "SMALL_BULLETS",
  ARROW_BULLETS: "ARROW_BULLETS",
  PROCESS_STEPS: "PROCESS_STEPS"
};
const SmartBlockData_ColumnSize = {
  SMALL: "SMALL",
  MEDIUM: "MEDIUM",
  LARGE: "LARGE",
  EXTRA_LARGE: "EXTRA_LARGE"
};
const SmartBlockData_Orientation = {
  HORIZONTAL: "HORIZONTAL",
  VERTICAL: "VERTICAL"
};
const SmartBlockCellData_Type = {
  SOLID_BOXES: "SOLID_BOXES",
  NUMBERED_BOXES: "NUMBERED_BOXES",
  STATS: "STATS",
  BAR_STATS: "BAR_STATS",
  CIRCLE_STATS: "CIRCLE_STATS",
  SOLID_BOXES_ALTERNATING: "SOLID_BOXES_ALTERNATING",
  SOLID_JOINED_BOXES: "SOLID_JOINED_BOXES",
  SIDE_LINE_TEXT: "SIDE_LINE_TEXT",
  TOP_LINE_TEXT: "TOP_LINE_TEXT",
  OUTLINE_BOXES_WITH_TOP_CIRCLE: "OUTLINE_BOXES_WITH_TOP_CIRCLE",
  BIG_BULLETS: "BIG_BULLETS",
  SMALL_BULLETS: "SMALL_BULLETS",
  ARROW_BULLETS: "ARROW_BULLETS",
  PROCESS_STEPS: "PROCESS_STEPS"
};
const TocData_ListStyle = {
  BULLETED: "BULLETED",
  NUMBERED: "NUMBERED",
  LETTERS: "LETTERS",
  ROMAN: "ROMAN",
  PLAIN: "PLAIN",
  ALPHABETICAL_INDEX: "ALPHABETICAL_INDEX",
  ALPHABETICAL_INDEX_COMPACT: "ALPHABETICAL_INDEX_COMPACT"
};
const TocData_Indentation = {
  NESTED: "NESTED",
  FLAT: "FLAT"
};
const LATEST_VERSION = 1;
const RicosDocumentNodeType = {
  PARAGRAPH: "PARAGRAPH",
  TEXT: "TEXT",
  HEADING: "HEADING",
  BULLETED_LIST: "BULLETED_LIST",
  ORDERED_LIST: "ORDERED_LIST",
  LIST_ITEM: "LIST_ITEM",
  BLOCKQUOTE: "BLOCKQUOTE",
  CODE_BLOCK: "CODE_BLOCK",
  VIDEO: "VIDEO",
  DIVIDER: "DIVIDER",
  FILE: "FILE",
  GALLERY: "GALLERY",
  GIF: "GIF",
  HTML: "HTML",
  IMAGE: "IMAGE",
  LINK_PREVIEW: "LINK_PREVIEW",
  POLL: "POLL",
  SHAPE: "SHAPE",
  APP_EMBED: "APP_EMBED",
  BUTTON: "BUTTON",
  COLLAPSIBLE_LIST: "COLLAPSIBLE_LIST",
  COLLAPSIBLE_ITEM: "COLLAPSIBLE_ITEM",
  COLLAPSIBLE_ITEM_TITLE: "COLLAPSIBLE_ITEM_TITLE",
  COLLAPSIBLE_ITEM_BODY: "COLLAPSIBLE_ITEM_BODY",
  TABLE: "TABLE",
  TOC: "TOC",
  EMBED: "EMBED",
  TABLE_CELL: "TABLE_CELL",
  TABLE_ROW: "TABLE_ROW",
  EXTERNAL: "EXTERNAL",
  AUDIO: "AUDIO",
  CAPTION: "CAPTION",
  LAYOUT: "LAYOUT",
  LAYOUT_CELL: "LAYOUT_CELL",
  CARD: "CARD",
  SMART_BLOCK: "SMART_BLOCK",
  SMART_BLOCK_CELL: "SMART_BLOCK_CELL",
  // for compat with legacy node
  UNRECOGNIZED: "UNRECOGNIZED",
  MAP: "MAP"
};
const RichContent = {
  fromJSON: (content) => {
    return content;
  },
  toJSON: (content) => {
    return content;
  }
};
const Node_Type = RicosDocumentNodeType;
export {
  AppEmbedData_AppType,
  AppEmbedData_CardStyles_Alignment,
  AppEmbedData_CardStyles_Type,
  AppEmbedData_ImageStyles_AspectRatio,
  AppEmbedData_ImageStyles_Position,
  AppEmbedData_ImageStyles_Resizing,
  AppEmbedData_RibbonStyles_Placement,
  Background_Type,
  ButtonData_Styles_ButtonSize,
  ButtonData_Type,
  CollapsibleListData_Direction,
  Decoration_Type,
  DividerData_Alignment,
  DividerData_LineStyle,
  DividerData_Width,
  FileData_PDFSettings_ViewMode,
  FontSizeData_fontType,
  GIFData_GIFType,
  GalleryOptions_ItemStyle_Crop,
  GalleryOptions_Layout_Orientation,
  GalleryOptions_Layout_Type,
  GalleryOptions_Thumbnails_Alignment,
  Gradient_Type,
  HTMLData_Source,
  ImagePosition,
  ImageScaling,
  LATEST_VERSION,
  LayoutData_BannerOrigin,
  LayoutData_DesignTarget,
  LayoutData_ResponsivenessBehaviour,
  Link_Target,
  Node_Type,
  PluginContainerData_Alignment,
  PluginContainerData_Width_Type,
  PollData_Design_PollDesign_Background_Type,
  PollData_Layout_PollLayout_Direction,
  PollData_Layout_PollLayout_Type,
  PollData_Poll_Settings_Permissions_ViewRole,
  PollData_Poll_Settings_Permissions_VoteRole,
  RichContent,
  RicosDocumentNodeType,
  SmartBlockCellData_Type,
  SmartBlockData_ColumnSize,
  SmartBlockData_Orientation,
  SmartBlockData_Type,
  TextStyle_TextAlignment,
  TocData_Indentation,
  TocData_ListStyle,
  VerticalAlignment
};
//# sourceMappingURL=ricos_document.js.map
